import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  ViewContainerRef,
  ViewChild,
  TemplateRef,
  OnInit
} from '@angular/core';
import { ElementRef, Renderer2 } from '@angular/core';
import { FeatureFlagService } from '../../services/feature-flag.service';
// Data Model
import { SortModel } from '../../models/data.model'
declare var $: any;


@Component({
  selector: 'app-sort',
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss']
})
export class SortComponent implements OnInit, OnChanges, AfterViewInit {

  windowObj: any = window;

  @ViewChild('sortDropdownItemContainer', { read: ViewContainerRef, static: true })
  sortDropdownItemContainer!: ViewContainerRef;
  @ViewChild('themeBuilderEnabledTemplate', { read: TemplateRef, static: true })
  themeBuilderEnabledTemplate!: TemplateRef<any>;
  @ViewChild('defaultTemplate', { read: TemplateRef, static: true })
  defaultTemplate!: TemplateRef<any>;
  @ViewChild('DSTV2Template', { read: TemplateRef, static: true })
  DSTV2Template!: TemplateRef<any>;

  @Input()
  sortRules!: SortModel[];
  @Input()
  activeSortRule!: SortModel;
  @Output() activeSortRuleEmitter: EventEmitter<SortModel> = new EventEmitter<SortModel>();
  @ViewChild('sortId', { static: true })
  el!: ElementRef;

  public arriaExpanded: Boolean = false;
  public selectedSortRuleIndex!: Number;
  public defaultSorted: Boolean = false;
  public isThemeBuilderEnabled: boolean;
  public enableDstV2Theme: boolean;

  constructor(private rd: Renderer2, private _featureFlagService: FeatureFlagService) {
    this.isThemeBuilderEnabled = this.windowObj.SWY.CONFIGSERVICE.isThemeBuilderEnabled;
    this.enableDstV2Theme = _featureFlagService.hasPageV2Theme();
  }

  public doSortEmitter(activeSortRule: SortModel) {
    this.activeSortRule = activeSortRule;
    this.activeSortRuleEmitter.emit(this.activeSortRule);

    // update datalayer
    if (this.windowObj['AB']['DATALAYER'] && this.activeSortRule && this.activeSortRule.label) {
      this.windowObj['AB']['DATALAYER'].sortBy(this.activeSortRule.label);
    }
  }

  /**
   * Triggered on properties changes - Search and update new active sort rule index
   *
   * @param {SimpleChanges} changes properties that has been changed
   */
  public ngOnChanges(changes: SimpleChanges): void {

    if (changes['activeSortRule']) {
      this.sortRules.forEach(
        (sort, i) => {

          if (this.activeSortRule && sort.field === this.activeSortRule.field) {
            this.selectedSortRuleIndex = i;
            sort.selected = true;
            this.defaultSorted = true;

          } else {
            sort.selected = null;
          }
        }
      );
    }
  }

  /**
   * Call Accessibility ARIA methods
   */
  public ngAfterViewInit(): void {

    this.sortByComponent();
  }

  public ngOnInit(): void {
    this.loadSortDropdownItemContainer();
  }

  public loadSortDropdownItemContainer() {
    switch (true) {
      case this.enableDstV2Theme:
        this.sortDropdownItemContainer.createEmbeddedView(this.DSTV2Template);
        break;
      case this.isThemeBuilderEnabled:
        this.sortDropdownItemContainer.createEmbeddedView(this.themeBuilderEnabledTemplate);
        break;
      default:
        this.sortDropdownItemContainer.createEmbeddedView(this.defaultTemplate);
        break;
    }
  }

  /* Sort by, Angular dropdown component ARIA , Taken from ARIA.JS*/
  public sortByComponent = () => {
    const sortBy = $('.dropdown-sort-by.dropdown');
    const sortByButton = sortBy.find('#sortByID');

    $('.sort-by-text').focusout(() => {
      $(this).css('outline', 'none');
    });

    /* aria-expanded removed when dropdown list is hidden + focus changing*/
    sortBy.on('hidden.bs.dropdown', function (e: any) {
      e.preventDefault();
      setTimeout(function () {
        $('#sortByID').focus();
      }, 300);
    });

    // to add the showPromo class for filters in mobile view
    if ($('div.cfh-banner.cfh-banner__search').length > 0) {
      $('#filterMV').addClass('showPromo');
    }

    $(document).not('.squaredThree').on('click', 'label', (e: any) => {
      $(this).css('outline', 'none');
    });

    $('.label-more').on('click', (e: any) => {
      $(this).prev().children(':eq(5)').children('label').css('outline', 'none');
    });
  };

  public removeVowels(option: string) {
    return option.toLowerCase().replace(/ /g, '').replace(/[aeiou]/g, '');
  }

}